<script>
export default {};
</script>

<template>
  <div class="base-card">
    <slot></slot>
  </div>
</template>

<style scoped>
.base-card {
  background: #fff;
  box-shadow: 1px 0 20px 2px rgba(175, 179, 182, 0.14);
  padding: 20px 20px;
  max-width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/_base/Card.vue